import { useEffect, useState } from 'react'
import { MdOutlineSupportAgent } from "react-icons/md";
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import { RxCross1 } from 'react-icons/rx';
import { BsSearch } from 'react-icons/bs';
import { RiArrowDownSFill } from 'react-icons/ri';
import Pagination from '../../../components/Pagination';
import { getTicketStatusesByAttribute } from '../../../services/TicketStatus';
import { appName } from '../../../config/api';
import { getIncidentsReportByTenantIdByAppName, getIncidentsReportByTenantIdByAppNameAndSearchWithIncidentName, getIncidentsReportByTenantIdByAppNameWithStatus, getIncidentsReportByTenantIdByAppNameWithStatusAndSearchWithIncidentName } from '../../../services/Tickets';
import useGroup from '../../../hook/useGroup';
import Cookies from 'js-cookie';
import { formatDateTimeForDisplay } from '../../../utils/getUserDateFormat';

const heading = ["Actions", "ID", "Subject", "Assigned Agent", "Created Date", "Status"];

const SupportTickets = () => {
  const { isSuperAdmin }: any = useGroup();
  const tenantId = Cookies.get("tenantId-my-cdir") || "";
  const pathRoot = isSuperAdmin ? "superadmin" : "admin";
  const navigate = useNavigate();
  const [showEntries, setShowEntries] = useState<number>(10);
  const [searchTableData, setSearchTableData] = useState<any[]>([]);
  const [searchValue, setSearchValue] = useState<string>("");
  const [displayFilter, setDisplayFilter] = useState<boolean>(false);
  const [eventFilterValue, setEventFilterValue] = useState(0);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [paginationModel, setPaginationModel] = useState<{ page: number, size: number }>({
    page: 0,
    size: 10,
  });
  const [totalLength, setTotalLength] = useState<number>(0);
  const [selectedFilter, setSelectedFilter] = useState<string>("Subject");
  const [isFirstTime, setIsFirstTime] = useState<boolean>(true);
  const [statusData, setStatusData] = useState<{ value: string, label: string }[]>([]);
  const [selectedStatus, setSelectedStatus] = useState<string>("All");

  useEffect(() => {
    if (!isFirstTime) {
      setSelectedFilter("Subject");
      setEventFilterValue(0);
      if (searchValue !== "") {
        setSearchValue("");
        setIsFirstTime(false);
      }
      else {
        setPaginationModel({
          page: 0,
          size: 10
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!isFirstTime) {
      setPaginationModel({
        page: 0,
        size: 10
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (searchValue === "" && !isFirstTime) {
      const newPaginationModel = {
        page: 0,
        size: paginationModel.size,
      };

      setPaginationModel(newPaginationModel);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue]);

  useEffect(() => {
    if (searchValue === "") {
      setIsFirstTime(false)
      apiCall(paginationModel);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationModel])

  useEffect(() => {
    const attribute = 'Incidents';
    getTicketStatusesByAttribute(attribute)
      .then((res) => {
        setStatusData(res?.reverse().map((item: any) => ({
          value: item?.id,
          label: item?.status
        })));
      })
      .catch((error) => {
        console.error('Error fetching ticket statuses:', error);
      });
  }, []);

  const apiCall = (newPaginationModel: { page: number, size: number }) => {
    setIsDataLoaded(true);

    const fetchData = selectedStatus === "All"
      ? getIncidentsReportByTenantIdByAppName(appName, tenantId, newPaginationModel.page, newPaginationModel.size)
      : getIncidentsReportByTenantIdByAppNameWithStatus(selectedStatus, appName, tenantId, newPaginationModel.page, newPaginationModel.size);

    fetchData
      .then((data) => {
        const result = data?.incidentReports.map((item: any) => ({
          ...item,
          createdAt: item?.createdAt ? format(new Date(item?.createdAt), "MM/dd/yyyy hh:mm a") : "No date",
        }));

        setSearchTableData(result || []);
        setTotalLength(data?.count || 0);
      })
      .catch((error) => {
        console.log(error);
        setSearchTableData([]);

        setTotalLength(0);
      })
      .finally(() => {
        setIsDataLoaded(false);
      });
  };

  useEffect(() => {
    if (statusData.length > 0) {
      const newPaginationModel = { page: 0, size: paginationModel.size };
      setPaginationModel(newPaginationModel);
      apiCall(newPaginationModel);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStatus]);

  useEffect(() => {
    let timeOutId: NodeJS.Timeout;

    if (searchValue !== "") {
      timeOutId = setTimeout(() => {
        const newPaginationModel = {
          page: 0,
          size: paginationModel.size,
        };

        setPaginationModel(newPaginationModel);

      }, 1000);
    }

    return () => clearTimeout(timeOutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue]);

  useEffect(() => {
    if (searchValue !== "" && !isFirstTime) {
      filterApiCall(paginationModel);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationModel])

  const filterApiCall = (newPaginationModel: { page: number, size: number }) => {
    let filterData: any[] = [];
    setIsDataLoaded(true);
    switch (eventFilterValue) {
      case 0:
        const fetchData = selectedStatus === "All"
          ? getIncidentsReportByTenantIdByAppNameAndSearchWithIncidentName(searchValue, appName, tenantId, newPaginationModel.page, newPaginationModel.size)
          : getIncidentsReportByTenantIdByAppNameWithStatusAndSearchWithIncidentName(searchValue, selectedStatus, appName, tenantId, newPaginationModel.page, newPaginationModel.size);

        fetchData
          .then((data) => {
            filterData = data?.incidentReports.map((item: any) => {
              return {
                ...item,
                createdAt: item?.createdAt ? format(new Date(item?.createdAt), "MM/dd/yyyy hh:mm a") : "No date",
              };
            });

            setSearchTableData(filterData || []);
            setTotalLength(data?.count || 0);
          })
          .catch((error) => {
            console.log(error);
            setSearchTableData([]);
            setTotalLength(0);
          })
          .finally(() => {
            setIsDataLoaded(false);
          });
        break;

      default:
        setIsDataLoaded(false);
        setSearchTableData([]);
        setTotalLength(0);
        break;
    }
  };

  const applyFilter = () => {
    setSelectedFilter("Subject");
    setSearchValue("");
    setDisplayFilter(false);
  };

  const clearFilter = () => {
    setSearchValue("");
    setDisplayFilter(false);
  };

  const newSupportTicket = () => {
    navigate(`/${pathRoot}/tickets/newsupportticket`);
  }

  const editSupportTicket = (id: string) => {
    navigate(`/${pathRoot}/tickets/editsupportticket/${id}`);
  }

  return (
    <section className="event__container p-3 xm:p-4 overflow-x-hidden">
      {/* Header */}
      <div className="min-w-full flex flex-col xm:flex-row justify-between items-start xm:items-center gap-3">
        <h1 className="px-2 xm:px-4 py-1.5 flex items-center gap-2">
          <MdOutlineSupportAgent fontSize={20} />
          <span className="text-base xm:text-lg">Support Tickets</span>
        </h1>

        <div className="flex flex-col xm:flex-row gap-2 w-full xm:w-auto">
          <button
            className="bg-secondary hover:bg-custom-blue px-4 py-2 xm:py-1.5 rounded-sm text-white w-full xm:w-auto"
            onClick={newSupportTicket}
          >
            New Support Ticket
          </button>
        </div>
      </div>

      {/* STATUS FILTER */}
      <div className="bg-gray-100 px-2 pt-2 mt-2 rounded-lg shadow-md overflow-x-auto">
        <div className="flex gap-2 whitespace-nowrap">
          <button
            key="All"
            className={`px-4 py-2 text-xs xm:text-sm ${selectedStatus === "All"
              ? "bg-secondary text-white"
              : "bg-gray-100 text-black"
              }`}
            onClick={() => setSelectedStatus("All")}
          >
            All
          </button>

          {statusData.map((status) => (
            <button
              key={status.value}
              className={`px-4 py-2 text-xs xm:text-sm ${selectedStatus === status.value
                ? "bg-secondary text-white"
                : "bg-gray-100 text-black"
                }`}
              onClick={() => setSelectedStatus(status.value)}
            >
              {status.label}
            </button>
          ))}
        </div>
      </div>

      {/* FILTER + SEARCH */}
      <div className="flex flex-col xm:flex-row gap-3 justify-between xm:items-center border border-black p-2 mt-4">
        <div className="relative flex flex-col xm:flex-row gap-3 items-start xm:items-center w-full">

          <div className="relative w-full xm:w-auto">
            <button
              className="bg-secondary text-white px-3 py-2 xm:py-1 rounded-md flex items-center justify-between w-full xm:w-auto whitespace-nowrap"
              onClick={() => setDisplayFilter(!displayFilter)}
            >
              {selectedFilter}
              <RiArrowDownSFill className="ml-1" />
            </button>

            <div
              className={`${displayFilter ? "block" : "hidden"
                } absolute z-10 w-full xm:w-40 p-2 bg-white border border-black mt-2 xm:mt-0 xm:top-0 xm:left-full`}
            >
              <div className="flex justify-between">
                <label className="text-xs font-bold">Fields</label>
                <div
                  onClick={() => setDisplayFilter(false)}
                  className="w-4 h-4 cursor-pointer text-sm text-center"
                >
                  <RxCross1 />
                </div>
              </div>

              <select
                className="w-full text-xs py-1 border mt-1"
                value={eventFilterValue}
                onChange={(e) =>
                  setEventFilterValue(parseInt(e.target.value))
                }
              >
                <option value="0">Subject</option>
              </select>

              <div className="flex mt-2 justify-between">
                <button
                  className="text-xs bg-secondary text-white py-1 px-2 rounded-md mt-3 w-full mr-1 whitespace-nowrap"
                  onClick={() => applyFilter()}
                >
                  Apply Filter
                </button>

                <button
                  className="text-xs bg-secondary text-white py-1 px-2 rounded-md mt-3 w-full ml-1"
                  onClick={() => clearFilter()}
                >
                  Clear
                </button>
              </div>
            </div>
          </div>

          {/* SEARCH */}
          <div className="flex items-center gap-2 w-full border px-2 py-1 rounded xm:border-none">
            <div className="h-4 w-4 text-gray-900">
              <BsSearch />
            </div>

            <input
              type="text"
              placeholder="Search…"
              className="w-full text-sm xm:text-lg pl-2 outline-none"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className="my-2" />

      {!isDataLoaded ? (
        <>
          {/* TABLE */}
          <div className="w-full overflow-x-auto">
            <table className="min-w-[800px] w-full bg-white">
              <thead className="bg-gray-200 whitespace-nowrap">
                <tr>
                  {heading.map((item, index) => (
                    <th
                      key={index}
                      className="px-4 xm:px-6 py-2 text-left text-xs xm:text-sm font-semibold text-black"
                    >
                      {item}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody className="whitespace-nowrap">
                {searchTableData.length > 0 ? (
                  searchTableData.slice(0, showEntries).map((item, index) => (
                    <tr key={index} className="even:bg-blue-50">
                      <td className="px-4 xm:px-6 py-2">
                        <button
                          className="mr-4"
                          onClick={() => editSupportTicket(item.id)}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" className="w-5 fill-secondary hover:fill-custom-blue"
                            viewBox="0 0 348.882 348.882">
                            <path
                              d="m333.988 11.758-.42-.383A43.363 43.363 0 0 0 304.258 0a43.579 43.579 0 0 0-32.104 14.153L116.803 184.231a14.993 14.993 0 0 0-3.154 5.37l-18.267 54.762c-2.112 6.331-1.052 13.333 2.835 18.729 3.918 5.438 10.23 8.685 16.886 8.685h.001c2.879 0 5.693-.592 8.362-1.76l52.89-23.138a14.985 14.985 0 0 0 5.063-3.626L336.771 73.176c16.166-17.697 14.919-45.247-2.783-61.418zM130.381 234.247l10.719-32.134.904-.99 20.316 18.556-.904.99-31.035 13.578zm184.24-181.304L182.553 197.53l-20.316-18.556L294.305 34.386c2.583-2.828 6.118-4.386 9.954-4.386 3.365 0 6.588 1.252 9.082 3.53l.419.383c5.484 5.009 5.87 13.546.861 19.03z"
                              data-original="#000000" />
                            <path
                              d="M303.85 138.388c-8.284 0-15 6.716-15 15v127.347c0 21.034-17.113 38.147-38.147 38.147H68.904c-21.035 0-38.147-17.113-38.147-38.147V100.413c0-21.034 17.113-38.147 38.147-38.147h131.587c8.284 0 15-6.716 15-15s-6.716-15-15-15H68.904C31.327 32.266.757 62.837.757 100.413v180.321c0 37.576 30.571 68.147 68.147 68.147h181.798c37.576 0 68.147-30.571 68.147-68.147V153.388c.001-8.284-6.715-15-14.999-15z"
                              data-original="#000000" />
                          </svg>

                        </button>
                      </td>
                      <td className="px-4 xm:px-6 py-2 text-xs xm:text-sm">
                        {item.id}
                      </td>

                      <td className="px-4 xm:px-6 py-2 text-xs xm:text-sm">
                        {item.incidentName}
                      </td>

                      <td className="px-4 xm:px-6 py-2 text-xs xm:text-sm">
                        {item.assignedToUserName}
                      </td>

                      <td className="px-4 xm:px-6 py-2 text-xs xm:text-sm">
                        {formatDateTimeForDisplay(item.createdAt)}
                      </td>

                      <td className="px-4 xm:px-6 py-2 text-xs xm:text-sm">
                        <span
                          className={`px-2 xm:px-3 py-1 rounded-full text-white text-xs ${item.status === "New"
                            ? "bg-orange-500"
                            : item.status === "Resolved"
                              ? "bg-green-500"
                              : item.status === "Assigned"
                                ? "bg-secondary"
                                : item.status === "Pending Assignment"
                                  ? "bg-yellow-500"
                                  : item.status === "Closed"
                                    ? "bg-gray-500"
                                    : item.status === "Awaiting Input"
                                      ? "bg-purple-500"
                                      : item.status === "On Hold"
                                        ? "bg-indigo-500"
                                        : "bg-gray-300"
                            }`}
                        >
                          {item.status}
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={6} className="px-2 py-1 text-sm text-center h-52">
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {totalLength > 0 && (
            <div className="mt-6 flex flex-col xm:flex-row items-center justify-between gap-3">
              <Pagination
                pageOption={[5, 10, 15, 20, 25, 50, 75, 100]}
                totalLength={totalLength}
                paginationModel={paginationModel}
                setPaginationModel={setPaginationModel}
                showEntries={showEntries}
                setShowEntries={setShowEntries}
              />
            </div>
          )}
        </>
      ) : (
        <div className="min-w-full h-[300px] xm:h-[480px] flex justify-center items-center">
          <div className="flex flex-col items-center">
            <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-current border-r-transparent text-secondary"></div>
            <span className="text-sm mt-2">Loading...</span>
          </div>
        </div>
      )}
    </section>
  )
}

export default SupportTickets